import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

/**
 * What `render` draws, drawn again when the language changes and never
 * mounted anew: a draft, an open dialog, a live socket and the invite links
 * made on a page are kept. A component under `memo` that shows words calls
 * useTranslation() itself, since its props do not change with the language.
 */
export function Localized({ render }: { render: () => ReactNode }) {
  useTranslation();
  return <>{render()}</>;
}
